function removeMask(value) {
    if (value) {
        const stringValue = value.toString()
        const regex = /[R$()-.,/% ]/ig
        return stringValue.replace(regex, '')
    }
}

export default removeMask
